import { render, staticRenderFns } from "./comm-scene.vue?vue&type=template&id=ec576116&scoped=true"
import script from "./comm-scene.vue?vue&type=script&lang=js"
export * from "./comm-scene.vue?vue&type=script&lang=js"
import style0 from "./comm-scene.vue?vue&type=style&index=0&id=ec576116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec576116",
  null
  
)

export default component.exports